export default "__VITE_ASSET__CnM3SZnB__"